<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="margin-top: 12px;">
            <div style="font-weight: 700; font-size: 24px; line-height: 24px; text-align: center;">사커하우 활동량 랭킹 🏃🏻</div>
            <div style="display: flex; justify-content: center; margin-top: 12px; font-weight: 700; font-size: 12px; color: #808080; align-items: center; gap: 12px;">
                <div style="line-height: 24px;">집계기간 7일</div>
                <div style="width: 2px; height: 16px; background-color: #d9d9d9;"></div>
                <div style="line-height: 24px;">{{ current_date_time }} 기준</div>
                <div style="width: 2px; height: 16px; background-color: #d9d9d9;"></div>
                <div style="line-height: 24px;">실시간 업데이트</div>
            </div>
            <div style="margin-top: 4px; font-weight: 500; font-size: 14px; line-height: 24px; text-align: center; padding-bottom: 12px;">상위 100명의 7일간의 걸음 데이터를 바탕으로 집계된 랭크입니다.</div>
        </div>
        <div style="flex: 1; overflow-y: scroll; margin-top: 16px; padding: 0 12px; padding-bottom: 120px;">
            <div style="padding: 0 16px;">
                <div @click="$Util.showProfile(each.member_idx, '', '', each.is_temp_coach); $Util.sendEventClick('만보기_프로필클릭', true)" :ref="each.member_idx == $GlobalStore.loginInfo().idx ? 'myRank' : null" v-for="each, i in memberList" :key="i" style="display: flex; align-items: center; margin-bottom: 20px;">
                    <div>
                        <div v-if="i === 0"><img style="width: 24px;" :src="require('@/assets/img/rank_1.png')" alt=""></div>
                        <div v-if="i === 1"><img style="width: 24px;" :src="require('@/assets/img/rank_2.png')" alt=""></div>
                        <div v-if="i === 2"><img style="width: 24px;" :src="require('@/assets/img/rank_3.png')" alt=""></div>
                        <div style="font-size: 14px; width: 25px; font-weight: 900; color: #606060; line-height: 24px; text-align: center;" v-if="i > 2">{{ i + 1 }}</div>
                    </div>
                    <div style="display: flex; align-items: center; margin-left: 29px; flex: 1; gap: 4px;">
                        <div style="font-weight: 700; line-height: 24px;">{{ each.nic_name }}</div>
                        <template v-if="each.is_coach == '1'">
                            <img v-if="each.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </template>
                        <div v-else style="font-weight: 900; font-size: 15px; color: var(--color-main);">{{ each.position }}</div>
                    </div>
                    <div style="display: flex; gap: 4px;">
                        <div style="line-height: 24px; font-weight: 700;">{{ each.cnt }}</div>
                        <div style="line-height: 24px; font-weight: 700; font-size: 14px; color: #808080;">걸음</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="myRanking" style="position: absolute; opacity: 0.95; padding: 0 12px; width: 100%; bottom: 40px;">
            <div style="background: linear-gradient(90deg, #EBEBEB 0%, #F9DDC7 100%); padding: 16px; border-radius: 12px;">
                <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-bottom: 8px;">내 랭킹</div>
                <div style="display: flex; align-items: center;">
                    <div style="font-size: 14px; width: 25px; font-weight: 900; color: #606060; line-height: 24px; text-align: center;">{{ myRanking.rownum }}</div>
                    <div style="display: flex; align-items: center; flex: 1; gap: 4px; margin-left: 39px;">
                        <div style="font-weight: 700; line-height: 24px;">{{ myRanking.nic_name }}</div>
                        <div v-if="myRanking.is_temp_coach == 0" style="font-weight: 900; font-size: 15px; color: var(--color-main);">{{ myRanking.position }}</div>
                        <template v-else>
                            <img v-if="myRanking.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </template>
                    </div>
                    <div style="display: flex; gap: 4px;">
                        <div style="line-height: 24px; font-weight: 700;">{{ myRanking.cnt }}</div>
                        <div style="line-height: 24px; font-weight: 700; font-size: 14px; color: #808080;">걸음</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import moment from 'moment'
import { TEAM_TYPE } from '@/Constants'

export default {
    name: "ActivityRanking",
    components: { MercenaryHeader },
    data() {
        return {
            memberList: [],
            myRanking: null,
            current_date_time: '',
            TEAM_TYPE: TEAM_TYPE
        }
    },
    created() {
        this.current_date_time = this.$Util.getMDDHangulStr(moment().format('YYYY-MM-DD'));

        this.getActivityRankingList()
    },
    methods: {
        showMyRanking() {
            this.$nextTick(() => {
                const myRankEl = this.$refs.myRank?.[0]
                if (myRankEl) {
                    myRankEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            })
        },
        async getActivityRankingList() {
            const res = await this.$Axios.get('/api/member/step/ranking')

            const rankings = res.data.rankings
            const myRanking = res.data.ranking_mine

            this.myRanking = myRanking
            this.memberList = rankings
        }
    },
}
</script>

<style scoped>
.rank_num {
    font-size: 24px;
}
</style>